/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { CreatorModel, CreatorModelType } from './CreatorModel'
import { CreatorModelSelector } from './CreatorModel.base'
import { PlayerInfoModel, PlayerInfoModelType } from './PlayerInfoModel'
import { PlayerInfoModelSelector } from './PlayerInfoModel.base'
import { RootStoreType } from './index'

/**
 * DashboardGameBase
 * auto generated base class for the model DashboardGameModel.
 */
export const DashboardGameModelBase = ModelBase.named('DashboardGame')
  .props({
    __typename: types.optional(types.literal('DashboardGame'), 'DashboardGame'),
    bots: types.union(types.undefined, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    creator: types.union(
      types.undefined,
      types.late(() => CreatorModel)
    ),
    events: types.union(types.undefined, types.string),
    gameId: types.union(types.undefined, types.string),
    gameType: types.union(types.undefined, types.string),
    hash: types.union(types.undefined, types.string),
    players: types.union(types.undefined, types.array(types.late(() => PlayerInfoModel)))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DashboardGameModelSelector extends QueryBuilder {
  get bots() {
    return this.__attr('bots')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get events() {
    return this.__attr('events')
  }
  get gameId() {
    return this.__attr('gameId')
  }
  get gameType() {
    return this.__attr('gameType')
  }
  get hash() {
    return this.__attr('hash')
  }
  creator(
    builder: string | CreatorModelSelector | ((selector: CreatorModelSelector) => CreatorModelSelector) | undefined
  ) {
    return this.__child('creator', CreatorModelSelector, builder)
  }
  players(
    builder:
      | string
      | PlayerInfoModelSelector
      | ((selector: PlayerInfoModelSelector) => PlayerInfoModelSelector)
      | undefined
  ) {
    return this.__child('players', PlayerInfoModelSelector, builder)
  }
}
export function selectFromDashboardGame() {
  return new DashboardGameModelSelector()
}

export const dashboardGameModelPrimitives = selectFromDashboardGame().bots.createdAt.events.gameId.gameType.hash
